import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import { getNotifications } from '~/actions/notifications'
import { getUserCamps } from '~/actions/camps'
import { getUserInterests } from '~/actions/interests'
import { getUserBookmarks } from '~/actions/bookmarks'
import { getUserViewHistory } from '~/actions/viewhistory'

import TextTemplate from '../RegistrationParts/TextSlideTemplate'

export default class extends React.Component {
    static propTypes = {
		prevSlide: PropTypes.func,
		nextSlide: PropTypes.func,
		dispatch: PropTypes.func.isRequired,
		history: PropTypes.object.isRequired
	};

    componentDidMount() {
		this.props.dispatch( getNotifications() )
		this.props.dispatch( getUserCamps() )
		this.props.dispatch( getUserInterests() )
		this.props.dispatch( getUserBookmarks() )
		this.props.dispatch( getUserViewHistory() )
	}

    skip = () => {
		this.props.history.push('/')
	};

    render() {

		var content = (<p className="text-center text-white mbot30">
			So you can get the most out of Five to Nine Club, we’d like to ask you a few questions. This will help us make sure we’re giving you everything you need to reach your goals.
			<br /><br />
			We have a handful of simple questions that will make your time with Five to Nine Club much more productive.
		</p>);

		return (
			<TextTemplate 
				title={<i className="icon icon-question text-light-danger"></i>}
				content={content}
				continue={<i></i>}
				prevSlide={this.skip}
				prevSlideIcon={<span>Skip</span>}
				nextSlide={this.props.nextSlide}
				nextSlideIcon={'No Problem'}
				/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Registration/RegistrationSlides/QuestionsIntroSlidePart.jsx